<template>
  <div>
    <div v-if="searching" class="flex justify-center items-center">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
      <span class="sr-only">Loading...</span>
    </div>

    <div v-else>
      <!-- Companies results location -->
      <div class="mb-4 lg:mb-m">
        <p v-if="nearCity" class="text-center md:text-left text-chrome text-14 font-normal">
          Companies near {{ nearCity  }}
        </p>
      </div>

      <!-- Companies Listing -->
      <div class="grid gap-8 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
        <a
          v-for="(company, index) in companiesData.data"
          :key="index"
          :href="`/companies/${company['slug']}?tab=jobs&ss=1&pl=${nearCity ? nearCity : ''}`"
          :title="company['name']"
          class="flex"
          :id="`lc-company${company['id']}`"
        >
          <div
            class="listing-card border-2 border-solid border-transparent max-w-xl"
          >
            <div class="p-6 company-card flex items-center gap-4">
              <img
                class="flex object-contain w-16 h-16 rounded-md border border-solid border-chrome-lightest lazyload"
                :data-src="company['logo']"
                :alt="`${company['name']} Logo`"
                :title="`${company['name']} Logo`"
              />
              <div class="">
                <p
                  class="text-lg text-primary-darker font-medium mb-10px company-name"
                >
                  {{ company["name"] }}
                </p>

                <div class="text-sm text-onyx-lightest font-semibold flex">
                  <vs-icon
                    class="text-lg"
                    icon="icon-briefcase"
                    icon-pack="feather"
                  ></vs-icon>
                  <p class="text-14 ml-8px">
                    {{ getJobCountCopy(company["jobs_count"]) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>

      <!-- Pagination -->
      <div
        v-if="companiesData.last_page > 1"
        class="flex items-center justify-center mt-40px"
      >
        <pagination
          :data-set="companiesData"
          :data-param="fullUrl"
          :show-count-from="false"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import event from "../event";
import axios from "axios";

export default {
  props: {
    companies: {
      type: Array,
      required: true
    },
    prepopulateCity: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      fullUrl: '',
      companiesData: this.companies,
      searching: false,
      nearCity: '',
    }
  },

  methods: {
    getJobCountCopy(count) {
      let countPostfix = (count > 0 || count == 0) ? 's' : '';

      return count + ' open job' + countPostfix
    },

    filterCompanies(url, clearErrorMsg = true) {
      this.companiesData = [];
      this.searching = true;
      url = url.indexOf('is_ajax=1') === -1 ? (url.indexOf('?') === -1 ? url + '?is_ajax=1' : url + '&is_ajax=1') : url;

      axios.get(url)
        .then(({ data }) => {
          this.searching = false;
          this.companiesData = data.companies;
          this.nearCity = data.prepopulateCity;
          this.fullUrl = data.fullUrl;
          this.initialPageLoad = data.isNotInitialPageLoad;
          event.bus.$emit('ajax-search-error', !clearErrorMsg);
        }).catch(({response}) => {
          event.bus.$emit('ajax-search-error', false);
          // alert user of error plus load companies without pl
          this.filterCompanies(window.location.href, false);
        });
    }
  },

  mounted() {
    this.filterCompanies(window.location.href);

    let vm = this;

    event.bus.$on('selected-company-filter', function (url) {
      vm.filterCompanies(url);
    });
  }
}
</script>
